<template>
  <v-alert class="alert" dense type="error">
      {{text}}
  </v-alert>
</template>

<script>
  export default {
    name:'alert-error',
    props:['text']
  }
</script>

<style lang="scss" scoped>
.alert{
  width: 100%;
}
</style>